module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_beautifulandyummy.722c0591.jpg";